import { render, staticRenderFns } from "./BillTable.vue?vue&type=template&id=4c44f45d&scoped=true&"
import script from "./BillTable.vue?vue&type=script&lang=ts&"
export * from "./BillTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c44f45d",
  null
  
)

export default component.exports